// src/utils/trpc.ts
import { httpLink, loggerLink } from '@trpc/client';
import { createTRPCNext } from '@trpc/next';
import type { inferReactQueryProcedureOptions } from '@trpc/react-query';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import { env } from 'env/client.mjs';
// eslint-disable-next-line import/no-restricted-paths
import type { AppRouter } from 'server/routers/app/router';
import superjson from 'superjson';

const getBaseUrl = () => {
  if (typeof window !== 'undefined') return ''; // browser should use relative url
  if (env.NEXT_PUBLIC_APP_URL_WITH_SCHEME) {
    return env.NEXT_PUBLIC_APP_URL_WITH_SCHEME; // SSR should use current url
  }
  // TODO remove other return after migration to railway
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`; // SSR should use vercel url
  return `http://localhost:${process.env.PORT ?? 3000}`; // dev SSR should use localhost
};

export const trpc = createTRPCNext<AppRouter>({
  transformer: superjson,
  config() {
    return {
      links: [
        loggerLink({
          enabled: (opts) =>
            env.NEXT_PUBLIC_BP_ENV === 'development' ||
            (opts.direction === 'down' && opts.result instanceof Error),
        }),
        httpLink({
          url: `${getBaseUrl()}/api/trpc`,
          transformer: superjson,
        }),
      ],
    };
  },
  ssr: false,
});

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;
export type ReactQueryOptions = inferReactQueryProcedureOptions<AppRouter>;
